import { css, LitElement, html } from "lit";
import { property, customElement } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let OfferAddButton = class extends LitElement {
  constructor() {
    super(...arguments);
    this.selected = false;
    this.disabled = false;
  }
  render() {
    return html`
      <button class=${classMap({ "selected": this.selected })} ?disabled=${this.disabled}>
        ${this.selected ? this.removeLabel ? this.removeLabel : "Remove" : this.addLabel}
      </button>
  `;
  }
};
OfferAddButton.styles = css`
    :host {
      width: 100%;
    }

    button {
      width: 100%;
      border: 2px solid var(--default-vi-primary-color);
      border-radius: var(--default-vi-border-radius);
      font-size: var(--default-vi-font-lg);
      background-color: var(--default-vi-primary-color);
      color: var(--default-vi-primary-contrast-color);
      padding: 8px 0px;
      cursor: pointer;
      font-weight: bold;
    }

    button:hover {
      opacity: 0.85;
    }

    button.selected {
      background-color: transparent;
      color: var(--default-vi-primary-color);
    }

    button:disabled:hover {
      opacity: 100;
      cursor: default;
    }
  `;
__decorateClass([
  property({ type: Number })
], OfferAddButton.prototype, "type", 2);
__decorateClass([
  property()
], OfferAddButton.prototype, "addLabel", 2);
__decorateClass([
  property()
], OfferAddButton.prototype, "removeLabel", 2);
__decorateClass([
  property({ type: Boolean })
], OfferAddButton.prototype, "selected", 2);
__decorateClass([
  property({ type: Boolean })
], OfferAddButton.prototype, "disabled", 2);
OfferAddButton = __decorateClass([
  customElement("offer-add-button")
], OfferAddButton);
export {
  OfferAddButton
};
